<div class="chart-footer"><slot/></div>

<style>
	.chart-footer {
		font-size: 16px;
		font-weight: 400;
		color: #707071 ;
		margin: 16px 0 8px 0;
	}
</style>